module.exports = __webpack_public_path__ + "static/media/folder-tree.8f6585fb.svg";